// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** /core/client/common/Notifications/notifications.scss
 ** module id = 573
 ** module chunks = 9
 **/